<div [ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}">
    <div class="title">
        <h1 id="maincontent" tabindex="-1">{{'Glossary.Title' | translate}}</h1>
        <p tabindex="0">{{'Glossary.Paragraph' | translate}}</p>
    </div>

    <div class="search">
        <form fxFlex="100" fxLayout="row" fxLayoutAlign="center center" class="search-form" (ngSubmit)="getGlossary(searchField.value)">
            <label class="search-label" for="glossarySearch">{{'Search.KeywordsLabel' | translate}}</label>
            <mat-form-field fxFlex="100" class="keywords" appearance="none">
                <input id="glossarySearch" type="text" [formControl]="searchField" matInput placeholder="{{'Search.Placeholder' | translate}}">
            </mat-form-field>
            <button type="submit" mat-flat-button color="primary" [attr.aria-label]="'Home.Sections.Search' | translate">
				<mat-icon>search</mat-icon>
			</button>
        </form>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center">
        <div class="sort-by" fxLayout="row" fxLayoutAlign="end center">
            <label id="sortby-label">{{ 'Common.Controls.SortBy.Title' | translate }}</label>

            <mat-form-field appearance="outline">
                <mat-select aria-labelledby="sortby-label" ngModel [formControl]="categoryField" id="Content" (selectionChange)="sort(categoryField.value)">
                    <mat-option value="" selected>{{'Glossary.Desc' | translate}}</mat-option>
                    <mat-option value="0">{{'Glossary.Asc' | translate}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <a (click)="onClick()" class="button" aria-hidden="true">
        <mat-icon class="arrow">arrow_upward</mat-icon>
    </a>

    <!-- Display contents for currently selected letter -->
    <section class="glossary" *ngFor="let currentLetter of (letter !== null ? letter.split('') : alphabet)" [attr.aria-labelledby]="'glossary-letter-' + currentLetter">
        <div *ngIf="glossaryMap.get(currentLetter) !== undefined">
            <h2 [id]="'glossary-letter-' + currentLetter" tabindex="0">{{ currentLetter }}</h2>
            <dl *ngIf="sortAsc">
                <ng-container *ngFor="let key of getKeys(glossaryMap.get(currentLetter)) | keyvalue: valueAscOrder let first = first; ">
                    <mat-divider *ngIf="!first"></mat-divider>
                    <dt><h3 tabindex="0" appEllipsify [innerHtml]="highlight(key.value)"></h3></dt>
                    <dd tabindex="0">{{ glossaryMap.get(currentLetter).get(key.value) }}</dd>
                </ng-container>
            </dl>
            <dl *ngIf="!sortAsc">
                <ng-container *ngFor="let key of getKeys(glossaryMap.get(currentLetter)) | keyvalue: keyDescOrder let first = first; ">
                    <mat-divider *ngIf="!first"></mat-divider>
                    <dt><h3 tabindex="0" appEllipsify [innerHtml]="highlight(key.value)"></h3></dt>
                    <dd tabindex="0">{{ glossaryMap.get(currentLetter).get(key.value) }}</dd>
                </ng-container>
            </dl>
        </div>
    </section>
</div>